/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutExpressPaymentContainerViewProps } from './checkout-express-payment-container';

interface IContainerItemsComponent {
    isLoadingClassName: string;
    items: React.ReactNode[];
}

const ContainerItemsComponent: React.FC<IContainerItemsComponent> = ({ isLoadingClassName, items }) => (
    <div className={isLoadingClassName}>{items}</div>
);

const CheckoutExpressPaymentContainerView: React.FC<ICheckoutExpressPaymentContainerViewProps> = ({
    checkoutPlainContainerProps,
    items,
    isReady,
    waiting,
    title,
    headerProps
}) => {
    const isLoadingClassName: string = isReady ? 'showContainer' : 'notShowContainer';
    return (
        <Module {...checkoutPlainContainerProps}>
            <Node {...headerProps}>{title}</Node>
            {!isReady && waiting}
            <ContainerItemsComponent isLoadingClassName={isLoadingClassName} items={items} />
        </Module>
    );
};

export default CheckoutExpressPaymentContainerView;
